import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { RsBaseComponent } from '../rs-base.component';

@Component({
    selector: 'rs-select',
    templateUrl: './rs-select.component.html',
    styleUrls: ['./rs-select.component.scss', '../../../scss/styles.scss'],
    standalone: false
})
export class RsSelectComponent extends RsBaseComponent implements OnInit {
    @Input() public values;
    public formControl;

    constructor(private readonly translate: TranslateService) {
        super();
    }

    public ngOnInit() {
        super.ngOnInit();

        this.formControl = this.element.group.get(this.element.name);

        const placeHolderOption = {
            value: '',
            label: `Select ${this.translate.instant(this.element.elementOptions.label)}`,
            disabled: true,
            hidden: true,
            selected: true
        };

        this.values = [
            placeHolderOption,
            ...this.element.elementOptions.options.map(item => ({
                value: item.Value || item.value,
                label: item.Label || item.label || ''
            }))
        ];
    }

    public compareSelectValues = (left: any, right: any): boolean => {
        const leftIsNullish = left === null || typeof left === 'undefined';
        const rightIsNullish = right === null || typeof right === 'undefined';


        if (leftIsNullish && rightIsNullish) {
            return true;
        }

        if (rightIsNullish && left === '') {
            return true;
        }

        if (left === right) {
            return true;
        }

        if (leftIsNullish || rightIsNullish) {
            return false;
        }

        const leftId = left?.id ?? left?.Id ?? left?.payerId ?? left?.PayerId;
        const rightId = right?.id ?? right?.Id ?? right?.payerId ?? right?.PayerId;

        if (leftId !== null && typeof leftId !== 'undefined' && rightId !== null && typeof rightId !== 'undefined') {
            return String(leftId) === String(rightId);
        }

        return false;
    };
}
